import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ClipShare, ClipShareCreateParams } from "@/interfaces/clipShare";
import {  deleteClipShareAction } from "@/api/actions/clipShares";

interface DeleteClipShareParams {
  bookmarkId?: number;
  id: number;
}

export const useDeleteClipShare = (onSuccess?: () => void) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (params: DeleteClipShareParams): Promise<number> => {
      await deleteClipShareAction(params.id);
      return params.bookmarkId as number;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["clipShares"] });
      if (onSuccess) onSuccess();
    }
  });
};

export const useCreateClipShare = (onSuccess?: (data: ClipShare) => void) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (params: ClipShareCreateParams) => {
      const response = await fetch("/api/clipShares", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(params),
      });

      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.error || "Failed to create clip share");
      }

      return response.json() as Promise<ClipShare>;
    },
    onSuccess: (data) => {
      // Invalidate clip share related queries
      queryClient.invalidateQueries({ queryKey: ["clip_share"] });

      if (onSuccess) {
        onSuccess(data);
      }
    },
  });
};
